<template>
    <div class="menu">
        <div class="menu-warp">
            <div class="menu-side">
                <span class="all">全部服务</span>
                <ul class="child-menu" style="display: none;">
                    <li v-for="(list, index) in departmentList" v-if="index <= 4" :class="returnMenuList(index)" >
                        <i v-if="index == 0" class="icon-logo icon-nwk"></i>
                        <i v-if="index == 1" class="icon-logo icon-fk"></i>
                        <i v-if="index == 2" class="icon-logo icon-child"></i>
                        <i v-if="index == 3" class="icon-logo icon-zhongyi"></i>
                        <i v-if="index == 4" class="icon-logo icon-kq"></i>
                        <i class="arr"></i>
                        <div class="title">
                            <a href="javascript:;">{{ list.text }}</a>
                        </div>
                        <div class="menu-children">
                            <span v-for="(item, _index) in returnNewList(list.children)">
                                <a :href="returnNewHref(list.id)" @click="buttonCollect('web-index-department');" v-if="_index < 3">{{ item.text }}</a>
                                <span class="line" v-if="_index < 2 && _index < returnNewList(list.children).length  -1">|</span>
                            </span>
                        </div>
                        <div class="menu-third-children">
                            <dl v-for="item in list.children">
                                <dt>{{item.text}}</dt>
                                <dd>
                                    <span v-for="(list2, index) in item.children">
                                        <a @click="buttonCollect('web-index-department');" :href="returnNewHref(list.id)">{{list2.text}}</a>
                                        <span class="line" v-if="index < item.children.length  - 1">|</span>
                                    </span>
                                </dd>
                            </dl>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="menu-link">
                <a v-for="(item, index) in navLink" :data-index="index" :class="isSelected(item.isSelected)" :href="item.url" >{{item.title}}</a>
            </div>
            <div class="clear"></div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    import url from '../../../config/url';
    import common from '../../../static/js/common'
    export default {
        props:{
            pageType: {
                type: String,
                default: ""
            }
        },
        data() {
            return {
                departmentList : [],
                locationList:[],
                navLink:[]
            }
        },
        created: function () {
            this.getDepartmentList(); //获取菜单
            this.returnSelectedType();
        },
        mounted: function () {
            $(".menu-list").hover(function () {
                var _this = $(this);
                _this.addClass('selected');
            }, function () {
                var _this = $(this);
                _this.removeClass('selected');
            });
            if(this.pageType == ""){
                $(".menu-side").hover(function () {
                    $(".child-menu").show();
                }, function () {
                    $(".child-menu").hide();
                });
            }else{
                $(".child-menu").show();
            }


        },
        methods: {
            isSelected(flag){
                if(flag){
                    return "selected";
                }
            },
            returnSelectedType(){
                var _this = this;
                var route = _this.$route;
                var path = (route.path).toLocaleLowerCase();
                _this.navLink = [
                    {
                        url: url.commonRoot + "/" + window.areaPinyin,
                        title:"首页"
                    },{
                        url: url.listRoot + "/list/",
                        title:"健康商品"
                    },{
                        url: url.commonRoot + "/clinic/" + window.areaPinyin,
                        title:"预约诊所"
                    },{
                        url: url.commonRoot + "/doctor/" + window.areaPinyin,
                        title:"预约医生"
                    },{
                        url: url.commonRoot + "/health/",
                        title:"健康资讯"
                    },{
                        url: url.commonRoot + "/disease/",
                        title:"疾病手册"
                    },{
                        url: url.commonRoot + "/knowledge/",
                        title:"药品信息"
                    }];
                _this.navLink[0].isSelected = true;
                _this.navLink.forEach(function (item,index) {
                    if((path == "/" && item.title == "首页") || (_this.pageType == "index" && item.title == "首页")){
                        _this.navLink[index].isSelected = true;
                    }else if(path.indexOf("clinic") > 0 && item.title == "预约诊所"){
                        _this.navLink[0].isSelected = false;
                        _this.navLink[index].isSelected = true;
                    }else if(path.indexOf("doctor") > 0  && item.title == "预约医生"){
                        _this.navLink[0].isSelected = false;
                        _this.navLink[index].isSelected = true;
                    }else if(path.indexOf("knowledge") > 0 && item.title == "健康助手"){
                        _this.navLink[0].isSelected = false;
                        _this.navLink[index].isSelected = true;
                    }if(path.indexOf("health") > 0 && item.title == "健康资讯"){
                        _this.navLink[0].isSelected = false;
                        _this.navLink[index].isSelected = true;
                    }if(path.indexOf("list") > 0 && item.title == "健康产品"){
                        _this.navLink[0].isSelected = false;
                        _this.navLink[index].isSelected = true;
                    }
                });
            },
            buttonCollect(id){
                common.buttonCollect(id);
            },
            returnMenuList(index){
                return "menu-list menu-list-" + index;
            },
            returnNewHref(id){
                return url.commonRoot + "/clinic/" + window.areaPinyin + "/" +  id;
            },
            returnNewList(itemList){
                var newList = [];
                itemList.forEach(function (item) {
                    if(item.children != null && item.children.length > 0){
                        item.children.forEach(function (list) {
                            if(list.text.length < 4){
                                newList.push(list);
                            }
                        });
                    }
                });
                return newList;
            },
            getDepartmentList(){
                var _this = this;
                axios.get(url.departmentList)
                .then(function (response) {
                    var departmentList =  eval('(' + response.data.replace("var jsDepartmentList=","") + ')');
                    if (departmentList != null && departmentList instanceof Array && departmentList.length > 0) {
                        _this.departmentList = departmentList;
                    }
                })
                .catch(function (error) {
                    _this.$Message.error('数据获取失败,请稍后再试！');
                });
            },

        }
    }
</script>

<style scoped lang="scss">
    @import "../../../static/scss/page/menuBar";
</style>


// WEBPACK FOOTER //
// src/components/Common/menuBar.vue